import React from "react";
import MainContentCard from "../../Home/MainContentCard";
import ErrorBoundaryRoutes from "../../../components/shared/ErrorBoundaryRoutes";
import ListProductRequestIncomingChild from "./ListProductRequestIncomingChild";

const ListProductRequestIncoming = () => {
  return (
    <MainContentCard>
      <ErrorBoundaryRoutes page="PurchaseRequests" route="/incoming-requests">
        <ListProductRequestIncomingChild />
      </ErrorBoundaryRoutes>
    </MainContentCard>
  );
};

export default ListProductRequestIncoming;
